<template>
  <header class="header">
    <div class="header__info">
      <div class="logo link link--bg" @click="showScreen('missions')"></div>

      <HeaderUser v-if="!isClient" />

      <template v-if="isDesktop">
        <!-- <button :class="getButtonClass('stats')" @click="showScreen('stats')">
          {{ $t("header.stats") }}
          <span class="header__subline">{{ $t("header.stats_sub") }}</span>
        </button> -->

        <!-- <button :class="getButtonClass('arsenal')" @click="showScreen('arsenal')">
          {{ $t("header.arsenal") }}
          <span class="header__subline">{{ $t("header.arsenal_sub") }}</span>
        </button> -->

        <button :class="getButtonClass('faq')" @click="openFaqPage()">
          {{ $t("header.faq") }}
          <span class="header__subline">{{ $t("header.faq_sub") }}</span>
        </button>
      </template>
    </div>

    <div class="header__buttons">
      <HeaderWallets />
      <HeaderBuyButton @openPopup="openPopup" />
      <div v-if="showLanguages" class="lang">
        <LangSelector />
      </div>
    </div>
  </header>
</template>
<script>
import "@/assets/header/styles/header.styl";

import Cookie from "js-cookie";
import env from "@libs/util/environment";
import LangSelector from "@/components/Common/LanguageSelector";
import HeaderBuyButton from "./blocks/HeaderBuyButton";
import HeaderUser from "./blocks/HeaderUser";
import HeaderWallets from "./blocks/HeaderWallets";
import { mapGetters } from "vuex";

import WindowSizeMixin from "@/components/Common/WindowSizeMixin";

export default {
  name: "PageHeader",
  components: {
    LangSelector,
    HeaderBuyButton,
    HeaderUser,
    HeaderWallets,
  },
  mixins: [WindowSizeMixin],
  computed: {
    ...mapGetters("global", ["isClient"]),
    showLanguages() {
      return env.isMyGames();
    },
  },
  methods: {
    showScreen(screen = "missions") {
      this.$store.commit("global/writeCurScreen", screen);
    },
    openPopup(popup_name = "popup") {
      this.$emit("openPopup", popup_name);
    },
    getButtonClass(screen) {
      const current_screen = this.$store.state.global.cur_screen;

      return [
        "header__button header__subline__container link link--text",
        screen === current_screen ? "header__button--active" : "",
      ];
    },
    openFaqPage() {
      const user_language = Cookie.get("cur_language") || "en";
      const faq_pages = {
        ru: "https://ru.warface.com/node/1009875",
        en: "https://pc.warface.com/en/node/1225369",
        de: "https://pc.warface.com/en/node/1225369",
        fr: "https://pc.warface.com/en/node/1225369",
        es: "https://pc.warface.com/en/node/1225369",
        cn: "https://pc.warface.com/en/node/1225369",
      };

      const faq_url = env.isMailRu() ? faq_pages["ru"] : faq_pages[user_language];

      window.open(faq_url, "_blank");
    },
  },
};
</script>
